// The single source for site identity and the production base URL is site/site.json.
// The React app reads it here; scripts/*.mjs and vite.config.ts read the JSON directly.
// Changing the production domain is one edit to site/site.json.
import site from './site.json'

type NavItem = { label: string; href: string }

/** Retailer links on results. Off until a programme approves the site; see src/commerce.ts. */
export type CommerceConfig = {
  enabled: boolean
  retailer: string
  /** Search URL with `{query}` where the encoded product name goes. */
  searchUrl: string
  trackingParam: string
  trackingId: string
  /** The programme's required disclosure, word for word. */
  disclosure: string
}

/** Email sign-up for the shop air sheet. Off until the provider's form is configured. */
export type NewsletterConfig = {
  enabled: boolean
  provider: string
  /** The provider's hosted form endpoint. Empty keeps the form hidden even when enabled. */
  formAction: string
}

export const siteConfig = site as {
  name: string
  shortName: string
  description: string
  baseUrl: string
  googleAnalyticsMeasurementId: string
  googleAnalyticsPropertyId?: string
  googleAdSenseClientId?: string
  adPlaceholders: boolean
  accent: string
  navigation: NavItem[]
  legalNavigation: NavItem[]
  commerce: CommerceConfig
  newsletter: NewsletterConfig
}
